import { render, staticRenderFns } from "./ZPLEditor.vue?vue&type=template&id=913643b4&scoped=true"
import script from "./ZPLEditor.vue?vue&type=script&lang=js"
export * from "./ZPLEditor.vue?vue&type=script&lang=js"
import style0 from "./ZPLEditor.vue?vue&type=style&index=0&id=913643b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913643b4",
  null
  
)

export default component.exports